/**
 * Modal Summary Graph
 */
import React, { useState, useEffect } from 'react';
// Component
import Modal from 'js/shared-order/components/Modal';
import ButtonCustom from 'js/shared-order/components/Button';

// Components(Material-UI)
import { makeStyles } from '@material-ui/core/styles';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// Library
import moment from 'moment';
moment.locale('ja');

const useStyles = makeStyles(() => ({
  modalContent: {
    height: '340px',
    overflow: 'hidden',
    padding: '15px',
  },
  input: {
    padding: '15px',
  },
  inputRoot: {
    width: '100%',
  },
}));
const ModalSummaryGraph = (props) => {
  const classes = useStyles();
  const [graphData, setGraphData] = useState([]);

  const getDateLabel = (value) => {
    const date = moment(value);
    const dateLabel = {
      tick: date.format('D'),
      unit: `(${date.format('dd')})`,
    }
    if (props.tableType === 'hourly') {
      dateLabel.tick = date.format('H');
      dateLabel.unit = '時';
    }
    return dateLabel;
  }

  useEffect(() => {
    setGraphData(props.graphData.map(graph => {
      graph.dateTime = graph.date.format('YYYY-MM-DD HH:mm:ss');
      return graph;
    }));
  }, [props.graphData]);

  const CustomXAxisTick = (xAxis) => {
    const tickLabel = getDateLabel(xAxis.payload.value);
    return (
      <g transform={`translate(${xAxis.x},${xAxis.y})`}>
        <text dy={16} textAnchor="middle" fill="#666" fontSize="0.8rem">
          {tickLabel.tick}
        </text>
        <text dy={32} textAnchor="middle" fill="#666" fontSize="0.7rem">
          {tickLabel.unit}
        </text>
      </g>
    );
  };
  const CustomYAxisTick = (yAxis) => {
    return (
      <g transform={`translate(${yAxis.x},${yAxis.y})`}>
        <text textAnchor="end" dominantBaseline="central" fill="#666" fontSize="0.6rem">
          &yen;{yAxis.payload.value.toLocaleString()}
        </text>
      </g>
    );
  };
  const FooterActions = () => {
    return (
        <ButtonCustom
          title='戻る'
          borderRadius='28px'
          bgcolor='#828282'
          borderColor='#828282'
          width='176px'
          onClick={props.onClose}
        />
    );
  };

  return (
    <Modal
      open={props.open}
      title="グラフ"
      maxWidth="90%"
      onClose={props.onClose}
      actions={<FooterActions />}
    >
      <div className={classes.modalContent}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={graphData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="dateTime"
              height={40}
              interval={0}
              tick={<CustomXAxisTick />}
            />
            <YAxis tick={<CustomYAxisTick />} />
            <Tooltip
              formatter={(value, name, props) => [`¥${value.toLocaleString()}`, '売上', props]}
              labelFormatter={(value) => {
                const label = getDateLabel(value);
                return `${label.tick}${label.unit}`;
              }}
            />
            <Bar dataKey="totalBilling" fill="#FFA04B" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Modal>
  );
};

export default ModalSummaryGraph;
